import { pRetryFn } from '../index.js';
// eslint-disable-next-line @typescript-eslint/naming-convention
export function _Retry(opt = {}) {
  return (_target, _key, descriptor) => {
    const originalFn = descriptor.value;
    descriptor.value = pRetryFn(originalFn, opt);
    return descriptor;
  };
}